import get from 'lodash/get';
import { useTheme } from 'native-base';

type HTMLNode = {
  type?: string;
  data?: string;
  children?: HTMLNode[];
};

export function extractText(node: HTMLNode | null): string {
  if (!node) return '';
  if (node.type === 'text') return node.data || '';
  if (node.children) return node.children.map(extractText).join('');
  return '';
}

export function useHTMLLinkStyle() {
  const theme = useTheme();
  const linkColor = theme.colors.black;
  const bodyFont = get(theme, 'fonts.body') as string;
  const fontFamily = get(theme.fontConfig, [bodyFont, '700', 'normal']) as string;

  return {
    color: linkColor,
    fontFamily,
    fontWeight: '700' as const,
    textDecorationColor: linkColor,
    textDecorationLine: 'underline' as const,
    textDecorationStyle: 'solid' as const,
  };
}
